import React from 'react';
import PropTypes from 'prop-types';

const DropdownSection = ({ children }) => (
  <div className="dropdown-section">
    {children}
  </div>
);

DropdownSection.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
};

export default DropdownSection;



// WEBPACK FOOTER //
// ./library/app/components/Global/Dropdowns/DropdownSection.js